/**
 * Make Your Own Bundle - Interactive Bundle Builder with Product & Variant Selection
 * Supports dynamic variant selection (Units/Size), live pricing, and cart integration.
 */

(function() {
  'use strict';

  function formatPrice(cents, format) {
    if (window.wpbingo && window.wpbingo.Currency && typeof window.wpbingo.Currency.formatMoney === 'function') {
      return window.wpbingo.Currency.formatMoney(cents, format || window.moneyFormat || '₹{{amount}}');
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format || '₹{{amount}}');
    }
    // Fallback standard formatting (INR / general)
    var amount = (cents / 100).toFixed(2);
    if (amount.endsWith('.00')) {
      amount = (cents / 100).toFixed(0);
    }
    return '₹' + amount;
  }

  function initBundleBuilder(sectionEl) {
    if (!sectionEl || sectionEl.dataset.bundleInitialized === 'true') return;
    sectionEl.dataset.bundleInitialized = 'true';

    var sectionId = sectionEl.dataset.sectionId;
    var slotCount = parseInt(sectionEl.dataset.slotCount, 10) || 5;
    var pricingType = sectionEl.dataset.pricingType || 'sum';
    var discountPercent = parseFloat(sectionEl.dataset.discountPercent) || 0;
    var baseProductPrice = parseInt(sectionEl.dataset.baseProductPrice, 10) || 0;
    var cartAddMode = sectionEl.dataset.cartAddMode || 'individual';
    var mainVariantId = sectionEl.dataset.mainVariantId;
    var bundleTitle = sectionEl.dataset.bundleTitle || 'Make Your Own Bundle';

    // Parse Candidate Products
    var dataScript = document.getElementById('bundle-candidate-products-' + sectionId);
    var candidateProducts = [];
    if (dataScript) {
      try {
        candidateProducts = JSON.parse(dataScript.textContent || '[]');
      } catch (e) {
        console.error('Error parsing bundle candidate products:', e);
      }
    }

    // State: Slots array containing either null or { product, variant }
    var slots = new Array(slotCount).fill(null);
    var currentTargetSlot = 0;
    var bundleQty = 1;

    // DOM Elements
    var slotsContainer = sectionEl.querySelector('.bundle-slots-grid');
    var itemsList = sectionEl.querySelector('.bundle-items-list');
    var noticeBar = sectionEl.querySelector('.bundle-notice-bar');
    var finalPriceEl = sectionEl.querySelector('.bundle-final-price');
    var comparePriceEl = sectionEl.querySelector('.bundle-compare-price');
    var atcBtn = sectionEl.querySelector('.bundle-add-to-cart-btn');
    var atcBtnText = sectionEl.querySelector('.bundle-btn-text');
    var qtyInput = sectionEl.querySelector('.bundle-qty-input');
    var qtyMinusBtn = sectionEl.querySelector('.bundle-qty-minus');
    var qtyPlusBtn = sectionEl.querySelector('.bundle-qty-plus');

    // Modal Elements
    var modalBackdrop = sectionEl.querySelector('.bundle-modal-backdrop');
    var modalDialog = sectionEl.querySelector('.bundle-modal-dialog');
    var modalCloseBtn = sectionEl.querySelector('.bundle-modal-close-btn');
    var modalTargetSlotNum = sectionEl.querySelector('.bundle-target-slot-num');
    var modalSearchInput = sectionEl.querySelector('.bundle-modal-search-input');
    var modalBody = sectionEl.querySelector('.bundle-modal-body');

    // Setup Quantity Stepper
    if (qtyMinusBtn && qtyPlusBtn && qtyInput) {
      qtyMinusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
          bundleQty = val - 1;
          updatePricing();
        }
      });

      qtyPlusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
        bundleQty = val + 1;
        updatePricing();
      });

      qtyInput.addEventListener('change', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val < 1) val = 1;
        qtyInput.value = val;
        bundleQty = val;
        updatePricing();
      });
    }

    // Bind Slots and Item List clicks
    function bindSlotEvents() {
      // Top visual boxes
      var slotBoxes = sectionEl.querySelectorAll('.bundle-slot-box');
      slotBoxes.forEach(function(box) {
        box.addEventListener('click', function(e) {
          if (e.target.closest('.bundle-slot-remove-btn')) return;
          var index = parseInt(box.dataset.slotIndex, 10);
          openModal(index);
        });

        var removeBtn = box.querySelector('.bundle-slot-remove-btn');
        if (removeBtn) {
          removeBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            var index = parseInt(box.dataset.slotIndex, 10);
            clearSlot(index);
          });
        }
      });

      // Itemized summary rows
      var itemRows = sectionEl.querySelectorAll('.bundle-item-row');
      itemRows.forEach(function(row) {
        var titleBtn = row.querySelector('.bundle-item-title-btn');
        if (titleBtn) {
          titleBtn.addEventListener('click', function(e) {
            e.preventDefault();
            var index = parseInt(row.dataset.slotIndex, 10);
            openModal(index);
          });
        }
      });
    }

    bindSlotEvents();

    // Modal Functionality
    function openModal(slotIndex) {
      currentTargetSlot = slotIndex;
      if (modalTargetSlotNum) {
        modalTargetSlotNum.textContent = slotIndex + 1;
      }

      // Highlight target slot box
      sectionEl.querySelectorAll('.bundle-slot-box').forEach(function(box) {
        if (parseInt(box.dataset.slotIndex, 10) === slotIndex) {
          box.classList.add('is-active-target');
        } else {
          box.classList.remove('is-active-target');
        }
      });

      if (modalSearchInput) {
        modalSearchInput.value = '';
      }

      renderModalProducts('');
      modalBackdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      setTimeout(function() {
        if (modalSearchInput) modalSearchInput.focus();
      }, 100);
    }

    function closeModal() {
      modalBackdrop.classList.remove('is-open');
      document.body.style.overflow = '';
      sectionEl.querySelectorAll('.bundle-slot-box').forEach(function(box) {
        box.classList.remove('is-active-target');
      });
    }

    if (modalCloseBtn) {
      modalCloseBtn.addEventListener('click', closeModal);
    }

    if (modalBackdrop) {
      modalBackdrop.addEventListener('click', function(e) {
        if (e.target === modalBackdrop) {
          closeModal();
        }
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modalBackdrop.classList.contains('is-open')) {
        closeModal();
      }
    });

    // Modal Live Search
    if (modalSearchInput) {
      modalSearchInput.addEventListener('input', function() {
        var query = modalSearchInput.value.trim().toLowerCase();
        renderModalProducts(query);
      });
    }

    // Render Product Cards inside Modal
    function renderModalProducts(query) {
      if (!modalBody) return;
      modalBody.innerHTML = '';

      var filtered = candidateProducts.filter(function(prod) {
        if (!query) return true;
        return prod.title.toLowerCase().indexOf(query) !== -1;
      });

      if (filtered.length === 0) {
        var emptyDiv = document.createElement('div');
        emptyDiv.className = 'bundle-modal-empty-state';
        emptyDiv.textContent = 'No products found matching your search.';
        modalBody.appendChild(emptyDiv);
        return;
      }

      filtered.forEach(function(prod) {
        var card = document.createElement('div');
        card.className = 'bundle-modal-p-card';
        card.dataset.productId = prod.id;

        // Determine currently selected variant (default to first available or first)
        var selectedVariant = prod.variants.find(function(v) { return v.available; }) || prod.variants[0];

        // Left: Thumbnail
        var thumbWrap = document.createElement('div');
        thumbWrap.className = 'bundle-modal-p-thumb';
        var thumbImg = document.createElement('img');
        thumbImg.src = (selectedVariant && selectedVariant.image) || prod.featured_image || '';
        thumbImg.alt = prod.title;
        thumbImg.loading = 'lazy';
        thumbWrap.appendChild(thumbImg);
        card.appendChild(thumbWrap);

        // Middle: Info + Variant selector
        var infoWrap = document.createElement('div');
        infoWrap.className = 'bundle-modal-p-info';
        
        var nameEl = document.createElement('h5');
        nameEl.className = 'bundle-modal-p-name';
        nameEl.textContent = prod.title;
        infoWrap.appendChild(nameEl);

        // Variant selector if more than 1 variant or if variant title is meaningful
        var hasMultipleVariants = prod.variants.length > 1;
        var hasCustomVariantTitle = prod.variants.length === 1 && prod.variants[0].title !== 'Default Title';

        if (hasMultipleVariants || hasCustomVariantTitle) {
          var variantWrap = document.createElement('div');
          variantWrap.className = 'bundle-modal-variant-select-wrap';

          var varLabel = document.createElement('span');
          varLabel.className = 'bundle-modal-variant-label';
          varLabel.textContent = 'Size / Unit:';
          variantWrap.appendChild(varLabel);

          // Render variant options dropdown
          var select = document.createElement('select');
          select.className = 'bundle-modal-variant-select';

          prod.variants.forEach(function(v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title + (!v.available ? ' (Sold Out)' : ' - ' + formatPrice(v.price));
            if (!v.available) opt.disabled = true;
            if (selectedVariant && v.id === selectedVariant.id) opt.selected = true;
            select.appendChild(opt);
          });

          select.addEventListener('change', function() {
            var variantId = parseInt(select.value, 10);
            var chosen = prod.variants.find(function(v) { return v.id === variantId; });
            if (chosen) {
              selectedVariant = chosen;
              priceEl.textContent = formatPrice(chosen.price);
              if (chosen.image) {
                thumbImg.src = chosen.image;
              }
              selectBtn.disabled = !chosen.available;
              selectBtn.textContent = chosen.available ? 'Select Item' : 'Sold Out';
            }
          });

          variantWrap.appendChild(select);
          infoWrap.appendChild(variantWrap);
        }

        card.appendChild(infoWrap);

        // Right: Price & Select CTA
        var actionWrap = document.createElement('div');
        actionWrap.className = 'bundle-modal-p-action';

        var priceEl = document.createElement('div');
        priceEl.className = 'bundle-modal-p-price';
        priceEl.textContent = formatPrice(selectedVariant.price);
        actionWrap.appendChild(priceEl);

        var selectBtn = document.createElement('button');
        selectBtn.type = 'button';
        selectBtn.className = 'bundle-modal-select-btn';
        selectBtn.textContent = selectedVariant.available ? 'Select Item' : 'Sold Out';
        selectBtn.disabled = !selectedVariant.available;

        selectBtn.addEventListener('click', function() {
          assignSlot(currentTargetSlot, prod, selectedVariant);
          closeModal();
        });

        actionWrap.appendChild(selectBtn);
        card.appendChild(actionWrap);

        modalBody.appendChild(card);
      });
    }

    // Assign Product + Variant into Slot
    function assignSlot(slotIndex, prod, variant) {
      slots[slotIndex] = {
        product: prod,
        variant: variant,
        image: variant.image || prod.featured_image,
        title: prod.title,
        variantTitle: variant.title,
        price: variant.price
      };

      updateUI();
    }

    // Clear Slot
    function clearSlot(slotIndex) {
      slots[slotIndex] = null;
      updateUI();
    }

    // Update UI elements based on slots state
    function updateUI() {
      // 1. Update Top Visual Slot Boxes
      var slotBoxes = sectionEl.querySelectorAll('.bundle-slot-box');
      slotBoxes.forEach(function(box) {
        var idx = parseInt(box.dataset.slotIndex, 10);
        var slotData = slots[idx];

        if (slotData) {
          box.classList.add('is-filled');
          box.innerHTML = '<img class="bundle-slot-img" src="' + slotData.image + '" alt="' + slotData.title + '">' +
                          '<button type="button" class="bundle-slot-remove-btn" aria-label="Remove item">&times;</button>';
          
          var removeBtn = box.querySelector('.bundle-slot-remove-btn');
          if (removeBtn) {
            removeBtn.addEventListener('click', function(e) {
              e.stopPropagation();
              clearSlot(idx);
            });
          }
        } else {
          box.classList.remove('is-filled');
          box.innerHTML = '<span class="bundle-slot-empty-icon">+</span>';
        }
      });

      // 2. Update Itemized Summary List Rows
      var itemRows = sectionEl.querySelectorAll('.bundle-item-row');
      itemRows.forEach(function(row) {
        var idx = parseInt(row.dataset.slotIndex, 10);
        var slotData = slots[idx];
        var titleBtn = row.querySelector('.bundle-item-title-btn');
        var priceEl = row.querySelector('.bundle-item-price');

        if (slotData) {
          row.classList.remove('is-empty');
          var variantBadge = slotData.variantTitle !== 'Default Title' ? 
            '<span class="bundle-item-variant-tag">' + slotData.variantTitle + '</span>' : '';
          
          if (titleBtn) {
            titleBtn.innerHTML = '<span>' + slotData.title + '</span>' + variantBadge + 
              '<span class="bundle-item-edit-icon" title="Change product">✎</span>';
          }
          if (priceEl) {
            priceEl.textContent = formatPrice(slotData.price);
          }
        } else {
          row.classList.add('is-empty');
          if (titleBtn) {
            titleBtn.innerHTML = '<span>Please Select Your Product</span>' + 
              '<span class="bundle-item-edit-icon" title="Select product">✎</span>';
          }
          if (priceEl) {
            priceEl.textContent = '......';
          }
        }
      });

      // 3. Update Pricing
      updatePricing();

      // 4. Update Notice Alert Bar & ATC Button State
      var filledCount = slots.filter(function(s) { return s !== null; }).length;
      var isComplete = filledCount === slotCount;

      if (noticeBar) {
        if (isComplete) {
          noticeBar.classList.add('is-complete');
          noticeBar.innerHTML = '<span class="bundle-notice-icon">✓</span> All ' + slotCount + ' items selected! Ready to add to cart.';
        } else {
          noticeBar.classList.remove('is-complete');
          var remaining = slotCount - filledCount;
          noticeBar.innerHTML = '<span class="bundle-notice-icon">ℹ</span> Please select products for all items of the bundle (' + remaining + ' left).';
        }
      }

      if (atcBtn) {
        atcBtn.disabled = !isComplete;
      }
    }

    // Calculate & Display Total Pricing
    function updatePricing() {
      var totalCents = 0;
      var compareCents = 0;

      if (pricingType === 'base_product' && baseProductPrice > 0) {
        totalCents = baseProductPrice * bundleQty;
      } else {
        var sumCents = slots.reduce(function(acc, slot) {
          return acc + (slot ? slot.price : 0);
        }, 0);

        if (pricingType === 'discount_percent' && discountPercent > 0) {
          compareCents = sumCents * bundleQty;
          totalCents = Math.round(sumCents * (1 - discountPercent / 100)) * bundleQty;
        } else {
          totalCents = sumCents * bundleQty;
        }
      }

      if (finalPriceEl) {
        finalPriceEl.textContent = formatPrice(totalCents);
      }

      if (comparePriceEl) {
        if (compareCents > totalCents) {
          comparePriceEl.textContent = formatPrice(compareCents);
          comparePriceEl.style.display = 'inline-block';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
    }

    // Add To Cart Handler
    if (atcBtn) {
      atcBtn.addEventListener('click', function(e) {
        e.preventDefault();

        // Validate completion
        var firstEmptyIndex = slots.findIndex(function(s) { return s === null; });
        if (firstEmptyIndex !== -1) {
          if (noticeBar) {
            noticeBar.scrollIntoView({ behavior: 'smooth', block: 'center' });
            noticeBar.style.transform = 'scale(1.02)';
            setTimeout(function() { noticeBar.style.transform = 'none'; }, 300);
          }
          openModal(firstEmptyIndex);
          return;
        }

        // Add to cart payload
        atcBtn.classList.add('is-loading');
        atcBtn.disabled = true;

        var itemsPayload = [];
        var bundleId = 'bundle_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);

        if (cartAddMode === 'individual') {
          // Individual variants added to cart with hidden bundle grouping property
          itemsPayload = slots.map(function(slot) {
            return {
              id: slot.variant.id,
              quantity: bundleQty,
              properties: {
                '_bundle_id': bundleId
              }
            };
          });
        } else {
          // Parent bundle product added with contents listed in line item properties
          var properties = {
            '_bundle_id': bundleId,
            'Bundle Name': bundleTitle
          };

          slots.forEach(function(slot, idx) {
            var vTitle = slot.variantTitle !== 'Default Title' ? ' (' + slot.variantTitle + ')' : '';
            properties['Item ' + (idx + 1)] = slot.title + vTitle;
          });

          itemsPayload = [{
            id: mainVariantId,
            quantity: bundleQty,
            properties: properties
          }];
        }

        // Send to Shopify Cart API
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: itemsPayload })
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;

          // Theme drawer integration
          if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
            window.ajaxCart.load();
          }

          if (window.jQuery && window.jQuery('.js-drawer').length) {
            window.jQuery('body').addClass('drawer--open');
          }

          // Trigger general cart updated event
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

          // Show temporary success feedback on button
          if (atcBtnText) {
            var origText = atcBtnText.textContent;
            atcBtnText.textContent = 'ADDED TO CART ✓';
            setTimeout(function() {
              atcBtnText.textContent = origText;
            }, 2500);
          }
        })
        .catch(function(error) {
          console.error('Error adding bundle to cart:', error);
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;
          alert('Could not add bundle to cart. Please try again.');
        });
      });
    }

    // Initialize all slots as empty by default
    updateUI();
  }

  // Auto-init on page load and Shopify editor events
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.bundle-builder-section').forEach(initBundleBuilder);
  });

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.bundle-builder-section');
    if (section) {
      initBundleBuilder(section);
    }
  });

})();
